import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M3 4h7L7 7l9 9-1 1-9-9-3 3z'],
  height: 20,
  width: 20,
});
